<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="iccid" >
        <el-input v-model="queryParams.iccid" placeholder="ICCID" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item prop="realName">
        <el-input v-model="queryParams.realName" placeholder="姓名" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item  prop="phone">
        <el-input v-model="queryParams.phone" placeholder="手机号" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item  prop="status" >
        <el-select v-model="queryParams.status" filterable placeholder="实名状态" @change="search">
          <el-option
            v-for="item in options"
            :key="item.cardStatus"
            :label="item.operationName"
            :value="item.cardStatus"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="realName" label="姓名" align="center"></el-table-column>
      <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
      <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
      <el-table-column prop="msisdn" label="MSISDN" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.status == 2">已实名</el-tag>
          <el-tag v-else-if="row.status == 1" type="success">实名中</el-tag>
          <el-tag v-else-if="row.status == 3" type="danger">未通过</el-tag>
          <el-tag v-else type="warning">已注销</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain  icon="el-icon-view" @click="editRow(scope.row.id)" v-hasPermi="['authentication:card:detail']" >详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { cardCertList } from "@/api/api.js"; //实名列表
export default {
  name:"auths",
  data() {
    return{
      queryParams:{
        iccid:undefined,
        realName:undefined,
        phone:undefined,
        status:undefined
      },
      tableData:[],
      options: [
        {
          cardStatus: "1",
          operationName: "实名中 "
        },
        {
          cardStatus: "2",
          operationName: "已实名"
        },
        {
          cardStatus: "3",
          operationName: "未通过"
        },
      ],
      page: 1,
      pageSize: 20,
      total:0
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      cardCertList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 详情
    editRow(id){
      this.$router.push(`/authentication/cardAuth/`+id);
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
  },
  mounted() {
    this.initData();
  },
  created() {

  }
};
</script>


